import '../../styles/CaseManagement.css';

const DAY_MS = 86_400_000;

export function daysSince(createdAt) {
    if (!createdAt || typeof createdAt.toMillis !== 'function') return null;
    const elapsed = Date.now() - createdAt.toMillis();
    return Math.max(0, Math.floor(elapsed / DAY_MS));
}

export function ageLevel(days) {
    if (days <= 15) return 'fresh';
    if (days <= 24) return 'warning';
    return 'overdue';
}

export function shouldShowAge(createdAt, admissionStatus, archived) {
    if (archived) return false;
    if (admissionStatus === 'Closed') return false;
    return daysSince(createdAt) !== null;
}

function CaseAgeBadge({ createdAt, admissionStatus, archived }) {
    if (!shouldShowAge(createdAt, admissionStatus, archived)) return null;
    const days = daysSince(createdAt);
    const level = ageLevel(days);
    return (
        <span className={`case-age-badge case-age-badge--${level}`}>
            <span className="case-age-badge__count">{days}</span>
            <span className="case-age-badge__unit">days elapsed</span>
        </span>
    );
}

export default CaseAgeBadge;
